import { render, staticRenderFns } from "./HeaderCombo.vue?vue&type=template&id=50316e20&scoped=true&"
import script from "./HeaderCombo.vue?vue&type=script&lang=js&"
export * from "./HeaderCombo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCombo.vue?vue&type=style&index=0&id=50316e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50316e20",
  null
  
)

export default component.exports